import { Request } from 'hooks/requestHooks'
import { Reclaim } from 'interfaces/Reclaims'
import { renderReclaimField } from 'utils/reclaimRenderers'

interface ReclaimBasicDetailsProps {
    reclaim: Reclaim
    request?: Request | null
}

const ReclaimDetails = ({ reclaim, request }: ReclaimBasicDetailsProps) => {
    // Updated props
    const providerUrl = `/service/providers/provider/${reclaim.providerId}/profile`
    const requestUrl = `/service/requests/request/${reclaim.requestId}`
    const matchUrl = `/service/matches/match/${reclaim.match_id}`

    const displayInfo = {
        Status: renderReclaimField({ key: 'status', reclaim }),
        'Prospect Value': renderReclaimField({ key: 'prospect', reclaim }),
        'Key Account': renderReclaimField({ key: 'keyAccount', reclaim }),
        'Provider Name': renderReclaimField({ key: 'businessName', reclaim, providerUrl }),
        'Reclaim Created Date': renderReclaimField({ key: 'created', reclaim }),
        'Demand Request Status': renderReclaimField({ key: 'requestStatus', reclaim, request }),
        'Demand Name': renderReclaimField({ key: 'leadName', reclaim, requestUrl }),
        'Phone Lead': renderReclaimField({ key: 'phoneNumber', reclaim }),
        'Match Date': renderReclaimField({ key: 'matchDate', reclaim, matchUrl }),
        Reason: renderReclaimField({ key: 'reason', reclaim }),
        Comment: renderReclaimField({ key: 'extra_field', reclaim }),
    }

    return (
        <div className="bg-grey-500 p-4 rounded-xl shadow-xs border border-grey-700">
            <div className="space-y-2 text-md">
                {Object.entries(displayInfo).map(([label, value]) => (
                    <div key={label} className="flex justify-between gap-1">
                        <span className="text-dark capitalize font-bold">{label}:</span>
                        <span>{value}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ReclaimDetails
